import React from "react";
import { Button, Icon } from "react-materialize";
import FormFunc from "../../../utils/FormFunc";
import { useInfo } from "context/InfoContext";

export default function EmpProbationContent({
  boxName,
  userData,
  handleEvents,
}) {
  const { infos, filters, storeFilters } = useInfo();
  const isCannotEdit =
    userData?.user_sess?.userCanAccessHrAssign || userData?.user_sess?.isAdmin
      ? false
      : true;

  React.useEffect(() => {
    if (
      filters &&
      (!Array.isArray(filters.position_change) ||
        filters.position_change.length === 0)
    ) {
      storeFilters({
        ...filters,
        position_change: [
          {
            position: "",
            reason: "",
            start_date: null,
            end_date: null,
          },
        ],
      });
    }
  }, [filters, storeFilters]);

  return infos?.staff_id ? (
    <div
      key={"probation-content-" + boxName + "-" + filters.key_form}
      style={{ marginTop: "25px" }}
    >
      <div
        className={boxName + " row"}
        style={{
          borderTop: "2px solid #dcdbdb",
          padding: "25px 10px",
          marginTop: "10px",
        }}
      >
        <h3
          className="col s9"
          style={{ color: "#5a5a5a", marginBottom: "20px", paddingLeft: "0px" }}
        >
          Position Change(s)
        </h3>
        {!isCannotEdit ? (
          <div
            key={"btn-add-position-change"}
            className="col s3"
            style={{ paddingRight: "0px" }}
          >
            <Button
              className="light-blue accent-2"
              id="btn-add-position-change"
              node="button"
              waves="light"
              small={true}
              style={{
                marginBottom: "20px",
                paddingLeft: "5px",
                paddingRight: "5px",
                width: "170px",
                float: "right",
              }}
              onClick={handleEvents.BtnAddPositionChange.OnClick}
            >
              Position change
              <Icon left style={{ marginRight: "8px", fontSize: "1.3rem" }}>
                add
              </Icon>
            </Button>
          </div>
        ) : (
          ""
        )}
        {filters?.position_change &&
          (filters?.position_change).map((item, index) => {
            return (
              <div
                key={"position_change-" + index}
                className="col s12"
                style={{
                  border: "1px dashed #dcdbdb",
                  padding: "20px 10px 5px 10px",
                  borderRadius: "12px",
                  marginBottom: "20px",
                }}
              >
                <div className={boxName + " row"}>
                  <FormFunc.InputText
                    data={{
                      id: "position_change_job_title_" + index,
                      name: "position_change_job_title",
                      label: "Position Change",
                      addClass: "col s6",
                      defaultValue: item.position,
                      disabled: isCannotEdit,
                    }}
                    events={handleEvents}
                  />
                  <FormFunc.SingleSelect
                    data={{
                      id: "position_change_reason_" + index,
                      name: "position_change_reason",
                      label: "Reason for Change",
                      options: [
                        { name: "promotion" },
                        { name: "demotion" },
                        { name: "transfer" },
                        { name: "change is salary" },
                        { name: "termination" },
                        { name: "other" },
                      ],
                      addClass: "col s6",
                      addStyle: { marginBottom: "20px" },
                      optionName: "name",
                      optionValue: "name",
                      optionTitle: "---",
                      optionNull: true,
                      defaultValue: item.reason ?? "",
                      disabled: isCannotEdit,
                    }}
                    filters={filters}
                    events={handleEvents}
                  />
                </div>
                <div className={boxName + " row"}>
                  <FormFunc.InputDate
                    data={{
                      id: "position_change_start_date_" + index,
                      name: "position_change_start_date",
                      label: "Effective Start Date",
                      addClass: "col s6",
                      defaultValue: item.start_date,
                      disabled: isCannotEdit,
                    }}
                    events={handleEvents}
                  />
                  <FormFunc.InputDate
                    data={{
                      id: "position_change_end_date_" + index,
                      name: "position_change_end_date",
                      label: "Effective End Date",
                      addClass:
                        "col " +
                        (!isCannotEdit &&
                        filters?.position_change &&
                        filters.position_change.length > 1 &&
                        index > 0
                          ? "s5"
                          : "s6"),
                      defaultValue: item.end_date,
                      disabled: isCannotEdit,
                    }}
                    events={handleEvents}
                  />
                  {!isCannotEdit &&
                  filters?.position_change &&
                  filters.position_change.length > 1 &&
                  index > 0 ? (
                    <div className="col s1">
                      <Button
                        className="red accent-2"
                        floating
                        node="button"
                        waves="light"
                        icon={<Icon>delete</Icon>}
                        style={{ marginTop: "25px", float: "right" }}
                        index={index}
                        onClick={handleEvents.BtnDeletePositionChange.OnClick}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  ) : (
    ""
  );
}
